/* eslint-disable indent */
/* eslint-disable max-lines-per-function */
/* eslint-disable react/no-unknown-property */
import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { Fieldset } from 'primereact/fieldset';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import SignaturePad from 'react-signature-canvas';
import * as moment from 'moment';
import Fab from '@material-ui/core/Fab';
import EditIcon from '@material-ui/icons/Edit';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Sidebar } from 'primereact/sidebar';
import LogAceite from '../logAceites';
import StatusRemessa from './monitorar-status-remessa';
import ValorAdesao from './valorAdesao';
import { BuscaInscricao } from '../../services/inscricao';
import { insereMensalidade, atualizaMensalidade } from '../../services/contratos/index';
import Pdf from '../pdf/index';
import FundoAmarelo from '../../assets/fundo_amarelo.png';
import './styles.css';
import CobrarAdesao from './cobrarAdesao';
import AceiEl from './aceiteEletronico';
import { BuscarDependentes } from '../../services/dependentes';
import DialogAvisoAssinatura from '../dialogs/dialog-aviso-assinatura';
import { BuscarAssoc, AtualizarStatus } from '../../services/associados';
import {
    insereAssinatura,
    BuscaAceiteUnico,
    BuscarImagem,
    BuscarDadosTestemunha
} from '../../services/assinaturas';
import { ListaAceites } from '../../services/linksAceite';
import calculateZeloPrime from '../../modulos/calcPrime';
import { showMessageError } from '../others/toastr';
import api from '../../services/backAxios';
import { cpf } from '../../modulos/validation/cpf';
import TrocaCartao from '../troca-cartao';
import { Calendar } from 'primereact/calendar';
import { ptBR } from '../../modulos/schemaDate';
import { retornoEtapasCadastro } from './/defineSteps';
import servicosAdicionaisService from '../../services/servicosAdicionais/servicosAdicionaisService';
import { decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import mensalidadeService from '../../services/mensalidades/mensalidadeService';
import ModalPlanoDesativado from '../modalPlanoDesativado/modalPlanoDesativado';
import comprovanteAdesao from './infra/comprovanteAdesao';
import { ListaStatusRemessa } from '../../services/remessa';
import ParcelarMensalidade from '../parcelar-mensalidade';

const Assinatura = props => {
    const history = useHistory();
    const growl = useRef(null);
    const { inscricao } = props.match.params;
    const [loading, setLoading] = useState('loading');
    const [ass, setAss] = useState(null);
    const [assTestemunha, setAssTestemunha] = useState(null);
    const [show, setShow] = useState(false);
    const [sucesso, setSucesso] = useState(false);
    const [erro, setErro] = useState(false);
    const [showCanvas, setShowCanvas] = useState(false);
    const [showCanvasTestemunha, setShowCanvasTestemunha] = useState(false);
    const [dependentes, setDependentes] = useState([]);
    const [servicosAdicionais, setServicosAdicionais] = useState([]);
    const [Associado, setAssociado] = useState(false);
    const [loadingAssociado, setLoadingAssociado] = useState(false);
    const sigCanvas = useRef({});
    const sigCanvasTestemunha = useRef({});
    const [valorDep, setValorDep] = useState([]);
    const [valorServicosAdicionais, setValorServicosAdicionais] = useState(null);
    const [valorInsc, setValorInsc] = useState(false);
    const [pagamentoAde, setPagamentoAde] = useState(false);
    const [valorAdesao, setValorAdesao] = useState(false);
    const [image, setImage] = useState([]);
    const [imageAssinaturaTestemunha, setImageAssinaturaTestemunha] = useState([]);
    const [dadosTestemunha, setDadosTestemunha] = useState();
    const [visibleFullScreen, setVisibleFullScreen] = useState(false);
    const [logsAceite, setLogsAceite] = useState(false);
    const [statusRemessa, setStatusRemessa] = useState(false);
    const [openDialogAssinaturaTitular, setOpenDialogAssinaturaTitular] =
        useState(true);
    const [openDialogAssinaturaTestemunha, setOpenDialogAssinaturaTestemunha] =
        useState(true);
    const [aceiteUnico, setAceiteUnico] = useState(false);
    const [assValor, setAssValor] = useState(false);
    const [popUpAdesao, setPopUpAdesao] = useState(false);
    const [pgInscricao, setPgInscricao] = useState();
    const [dataInsertInscricao, setdataInsertInscricao] = useState();
    const [valorPagoInscricao, setvalorPagoInscricao] = useState();
    const [tipoPagamento, setTipoPagamento] = useState();
    const [botaoAdesao, setBotaoAdesao] = useState(false);
    const [renderPdf, setRenderPdf] = useState(false);
    const [isAdesao, setAdesao] = useState(true);
    const header = <img alt="Card" src={FundoAmarelo} />;
    const [registroAdesao, setRegistroAdesao] = useState(false);
    const [valorTotal, setValorTotal] = useState();
    const [dadosRecorrencia, setDadosRecorrencia] = useState();
    const [idade, setIdade] = useState('');
    const items = [
        { label: 'Associado' },
        { label: 'Dependentes' },
        { label: 'Serviços Adicionais' },
        { label: 'Checkout' }
    ];
    const [formTestemunha, setFormTestemunha] = useState({
        nome: '',
        cpf: '',
        nascimento: ''
    });
    const [formTestemunhaValid, setFormTestemunhaValid] = useState(false);
    const [errFormTestemunhaNome, setErrFormTestemunhaNome] = useState('');
    const [errFormTestemunhaCpf, setErrFormTestemunhaCpf] = useState('');
    const [errFormTestemunhaNascimento, setErrFormTestemunhaNascimento] = useState('');
    const [assinadoTestemunha, setAssinadoTestemunha] = useState(false);
    const [assinadoTitular, setAssinadoTitular] = useState(false);
    const [loadingAssinaturas, setLoadingAssinaturas] = useState(false);
    const [mensalidadeBase, setMensalidadeBase] = useState(0);
    const [mensalidadeBaseDep, setMensalidadeBaseDep] = useState(0);
    const [origemCarne, setOrigemCarne] = useState('');
    const [linkCarne, setLinkCarne] = useState('');
    const [loadingCarne, setLoadingCarne] = useState(false);
    const coordenador = decriptoLocalStorage('codCoordenador')?.decriptoValue;
    const supervisor = decriptoLocalStorage('codSupervisor')?.decriptoValue;
    const nomeVendedor = decriptoLocalStorage('Nome')?.decriptoValue;

    useEffect(() => {
        async function loadAdesao() {
            await BuscaInscricao(inscricao)
                .then(result => {
                    if (result === null) {
                        setRegistroAdesao(true);
                    }

                    setTipoPagamento(result.tipoPagamento);
                    setPgInscricao(result.Pagamento);
                    setdataInsertInscricao(result.DataInsert);
                    setvalorPagoInscricao(result.valorPago);

                    if (result.Pagamento != null) {
                        setPgInscricao(result.Pagamento);
                        setPagamentoAde(true);
                    }

                    setValorInsc(result.Valor > 0 ? result.Valor : false);
                    setAdesao(false);
                })
                .catch(err => {
                    console.error('Adesão erro: ', err);
                    setValorInsc(false);
                });
        }

        loadAdesao();
    }, [inscricao]);

    useEffect(() => {
        async function search() {
            await ListaAceites(`${inscricao}`)
                .then(result => {
                    setLogsAceite(result);
                })
                .catch(err => console.error('Ocorreu um erro: ', err));
        }

        search();
    }, [inscricao]);

    useEffect(() => {
        async function search() {
            await ListaStatusRemessa(`${inscricao}`)
                .then(result => {
                    setStatusRemessa(result);
                })
                .catch(err => console.error('Ocorreu um erro: ', err));
        }

        search();
    }, [inscricao]);

    useEffect(() => {
        async function loadAceite() {
            await BuscaAceiteUnico(inscricao)
                .then(result => {
                    if (result.length > 0) {
                        setAceiteUnico(true);
                    }
                })
                .catch(error => {
                    throw new Error(error);
                });
        }

        loadAceite();
    }, [inscricao]);

    useEffect(() => {
        let valorTotalDep = 0;

        async function loadDependentes() {
            const regexValor = '/(\d)(?=(\d{3})+\,)/g';

            await BuscarDependentes(inscricao)
                .then(response => {
                    if (response.length > 0) {
                        const planoZTA = response[0]['Associado.Plano'].trim() === 'ZTA';

                        if (planoZTA) {
                            for (let i = 0; i < response.length; i++) {
                                response[
                                    i
                                ].valorDependente = `${response[i]['DependenteValorDinamico.valor'].toFixed(2).replace('.', ',').replace(regexValor, '$1.')}`;
                                valorTotalDep += response[i]['DependenteValorDinamico.valor'];
                            }
                        } else {
                            for (let i = 0; i < response.length; i++) {
                                response[
                                    i
                                ].valorDependente = `${response[i]['CategoriaParentesco.Valor'].toFixed(2).replace('.', ',').replace(regexValor, '$1.')}`;
                                valorTotalDep += response[i]['CategoriaParentesco.Valor'];
                            }
                        }
                    }

                    setValorDep(valorTotalDep);
                    setDependentes(response);

                    return response;
                })
                .catch(error => {
                    throw new Error(error);
                });
        }

        loadDependentes();
    }, [inscricao]);

    const baixarCarnetGerencianet = async origem => {
        try {
            setLoadingCarne(true);

            const carnet = await mensalidadeService.buscaCarnetGerencianet(
                inscricao,
                origem
            );

            if (carnet.size === 0 || carnet.type !== 'application/pdf') {
                throw new Error('Erro', 'Não foi encontrado carnê Gerencianet!');
            }

            const carnetLink = URL.createObjectURL(carnet);

            setLinkCarne(carnetLink);
        } catch (error) {
            showMessageError(
                'Erro',
                'O serviço está temporariamente indisponível. Por favor, tente novamente mais tarde.'
            );
        } finally {
            setLoadingCarne(false);
        }
    };

    const verficaElegivel = async () => {
        try {
            const elegivel = await mensalidadeService.consultaElegiveis(inscricao);

            setOrigemCarne(elegivel.Origem);

            if (elegivel.Origem) {
                await baixarCarnetGerencianet(elegivel.Origem);
            }
        } catch (error) {
            showMessageError(
                'Erro',
                'Não foi possível verificar se o cliente possui carnê!'
            );
        }
    };

    useEffect(() => {
        if (pgInscricao && Associado.Aceite === 'S') {
            verficaElegivel();
        }
    }, [inscricao, pgInscricao, Associado]);

    function bodyTemplateValorDependentes(rowData) {
        const { valorDependente } = rowData;
        const valorDependenteSelecionar = rowData['Associado.Plano'].trim() !== 'ZTA' ? valorDependente : String(rowData['DependenteValorDinamico.valor']);

        return rowData.valorDependente ?
            new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(valorDependenteSelecionar.replace(',', '.')) :
            new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format('0');
    }

    useEffect(() => {
        async function loadAssociado() {
            setLoadingAssociado(true);
            await BuscarAssoc(props.match.params.inscricao)
                .then(async response => {
                    if (
                        response[0].Vendedor !==
                        decriptoLocalStorage('codigo_vendedor')?.decriptoValue
                    ) {
                        history.push('/');
                        showMessageError(
                            'Acesso Negado',
                            'Você não tem permissão para acessar contratos de outros vendedores'
                        );
                    }

                    setAssociado(response[0]);
                    setBotaoAdesao(true);
                    setLoadingAssociado(false);
                })
                .catch(err => {
                    setLoadingAssociado(false);
                    throw new Error(err);
                });
        }

        loadAssociado();
    }, []);

    useEffect(() => {
        async function checaRecorrencia() {
            const { data } = await api.get(
                `/associados-status/recorrencia/${inscricao}`
            );

            setDadosRecorrencia(data);
        }

        checaRecorrencia();
    }, []);

    useEffect(() => {
        async function gravaMensalidade() {
            await insereMensalidade(inscricao)
                .then(_response => { })
                .catch(err => {
                    throw new Error(err);
                });
        }

        gravaMensalidade();
    }, [inscricao]);

    useEffect(() => {
        setValorAdesao(localStorage.getItem('ValorInscricao'));
    }, []);

    useEffect(() => {
        async function ValorUpdateMensalidade() {
            await atualizaMensalidade(inscricao)
                .then(_response => { })
                .catch(error => {
                    throw new Error(error);
                });
        }

        ValorUpdateMensalidade();
    }, [inscricao]);

    useEffect(() => {
        if (!Associado.payzentokencard) {
            atualizaMensalidade(inscricao)
                .then(_response => { })
                .catch(error => {
                    throw new Error(error);
                });
        }
    }, [Associado]);

    const calcularIdade = nascimento => {
        const dataNascimento = new Date(nascimento);
        const dataAtual = new Date();

        return Math.floor((dataAtual - dataNascimento) / 31556952000);
    };

    const handleNascimento = event => {
        const idadeMilisegundos = 31556952000;
        const dataNascimento = new Date(event.target.value);
        const dataAtual = new Date();

        setIdade(Math.floor((dataAtual - dataNascimento) / idadeMilisegundos));
    };

    const save = async ind => {
        if (!ass && !assinadoTitular && showCanvas) {
            if (sigCanvas.current.getTrimmedCanvas && !assinadoTitular) {
                setAss(sigCanvas.current.getTrimmedCanvas().toDataURL('image/png'));
                setAssinadoTitular(true);
                setShowCanvas(false);
            }
        }

        if (!assTestemunha && !assinadoTestemunha && showCanvasTestemunha) {
            if (sigCanvasTestemunha.current.getTrimmedCanvas && !assinadoTestemunha) {
                setAssTestemunha(
                    sigCanvasTestemunha.current
                        .getTrimmedCanvas()
                        .toDataURL('image/png')
                );
                setShowCanvasTestemunha(false);
                setShowCanvas(true);
                setAssinadoTestemunha(true);
            }
        }

        let obj = {
            id_ass_assoc: inscricao,
            ass_path: 'n/a'
        };

        setShow(!show);

        if (ind === 2) {
            if (ass) {
                if (ass.length > 400) {
                    obj = {
                        ...obj,
                        ass_b64: ass
                    };
                } else {
                    alert('ops, não detectamos traços suficientes');
                    setErro(true);

                    return;
                }
            }

            if (assTestemunha) {
                if (assTestemunha.length > 400) {
                    obj = Object.assign({}, obj, {
                        testemunha: {
                            nome: formTestemunha.nome,
                            cpf: tratarCpf(formTestemunha.cpf),
                            nascimento: formTestemunha.nascimento,
                            assTestemunha
                        }
                    });
                } else {
                    alert(
                        'ops, não detectamos traços suficientes na assinatura da testemunha'
                    );
                    setErro(true);

                    return;
                }
            }

            setLoadingAssinaturas(true);
            await insereAssinatura(inscricao, obj)
                .then(response => {
                    setLoading('nada');

                    if (response.status === 400) {
                        setLoadingAssinaturas(false);

                        setLoading('loading');
                        setTimeout(() => {
                            alert(
                                'ops, estamos tendo problemas para validar seus dados'
                            );
                        }, 2000);
                    } else if (response.status === 500) {
                        setLoadingAssinaturas(false);
                        setLoading('loading');
                        setTimeout(() => {
                            alert(
                                'ops, o servidor está tendo problemas para validar seus dados'
                            );
                        }, 2000);
                    }

                    if (response.message === 'sucessufuly') {
                        setSucesso(true);
                        setLoading('loading');
                        setShowCanvas(false);
                        window.location.reload();
                    }
                })
                .catch(err => {
                    alert(
                        'ops, estamos tendo problemas para validadar seus dados',
                        err
                    );
                });
        }
    };

    const tratarCpf = cpf => {
        cpf = cpf.replaceAll('_', '');
        cpf = cpf.replaceAll('.', '');
        cpf = cpf.replaceAll('-', '');

        return cpf;
    };

    const changeNomeTestemunha = async e => {
        setFormTestemunha({
            ...formTestemunha,
            nome: e.target.value
        });
        await validatorFormTestemunha('nome', { nome: e.target.value });
    };

    const changeCpfTestemunha = async e => {
        setFormTestemunha({
            ...formTestemunha,
            cpf: e.target.value
        });
        await validatorFormTestemunha('cpf', { cpf: tratarCpf(e.target.value) });
    };

    const changeNascimentoTestemunha = async e => {
        setFormTestemunha({
            ...formTestemunha,
            nascimento: e.target.value
        });
        await validatorFormTestemunha('nascimento', { nascimento: e.target.value });
    };

    const validatorFormTestemunha = async (campo, valor) => {
        let form;
        const validarIdadeTestemunha = moment(
            new Date().setFullYear(new Date().getFullYear() - 18)
        ).format('MM-DD-YYYY');
        const nome = yup.object().shape({
            nome: yup
                .string()
                .min(4, 'Por favor, digite um nome com mais de 04 caracteres')
                .required('Por favor, digite o nome')
        });
        const Cpf = yup.object().shape({
            cpf: yup
                .string()
                .min(11, 'Por favor, insira um cpf válido')
                .max(11)
                .required('Por favor, digite o CPF')
        });
        const nascimento = yup.object().shape({
            nascimento: yup
                .date()
                .max(
                    validarIdadeTestemunha,
                    'A testemunha precisa ter idade igual ou superior a 18 anos'
                )
                .required('Por favor, digite a data de nascimento.')
        });
        const shape = yup.object().shape({
            nome: yup.string().min(4).required('Por favor, digite o nome'),
            cpf: yup
                .string()
                .min(11, 'Por favor, insira um cpf válido')
                .max(11)
                .required('Por favor, digite o CPF'),
            nascimento: yup
                .date()
                .max(
                    validarIdadeTestemunha,
                    'A testemunha precisa ter idade igual ou superior a 18 anos'
                )
                .required('Por favor, digite a data de nascimento.')
        });

        switch (campo) {
            case 'nome':
                form = {
                    cpf: tratarCpf(formTestemunha.cpf),
                    nome: valor.nome
                };

                try {
                    await nome.validate(valor);
                    setErrFormTestemunhaNome('');
                } catch (err) {
                    setErrFormTestemunhaNome(err.message);
                }

                break;

            case 'nascimento':
                form = {
                    ...formTestemunha,
                    cpf: tratarCpf(formTestemunha.cpf),
                    nascimento: valor.nascimento
                };

                try {
                    await nascimento.validate(valor);
                    setErrFormTestemunhaNascimento('');
                } catch (err) {
                    setErrFormTestemunhaNascimento(err.message);
                }

                break;

            case 'cpf':
                form = {
                    ...formTestemunha,
                    cpf: valor.cpf
                };

                try {
                    await Cpf.validate(valor);

                    const cpfIsValid = cpf(valor.cpf);

                    if (cpfIsValid === true) {
                        setErrFormTestemunhaCpf('');
                    } else {
                        setErrFormTestemunhaCpf(cpfIsValid.mess);
                    }
                } catch (err) {
                    setErrFormTestemunhaCpf(err.message);
                }

                break;
        }

        try {
            await shape.validate(form);
            setFormTestemunhaValid(true);
        } catch (err) {
            console.log(err);
            setFormTestemunhaValid(false);
        }
    };

    const clear = ind => {
        setLoading('loading');

        if (ind === 1) {
            if (showCanvasTestemunha) {
                sigCanvasTestemunha.current.clear();
                setAssinadoTestemunha(false);
            }

            if (showCanvas) {
                sigCanvas.current.clear();
                setAssinadoTitular(false);
            }
        }

        if (ind === 2) {
            setOpenDialogAssinaturaTitular(true);
            setAssinadoTitular(false);

            if (calcularIdade(Associado.Nascimento) >= 65) {
                setOpenDialogAssinaturaTestemunha(true);
                setFormTestemunha({
                    nome: '',
                    cpf: '',
                    nascimento: ''
                });
                setFormTestemunhaValid(false);
                setAssinadoTestemunha(false);
                setShowCanvasTestemunha(true);
                setShowCanvas(false);
            } else {
                setShowCanvas(true);
                setShowCanvasTestemunha(false);
            }

            if (sigCanvasTestemunha.current && sigCanvasTestemunha.current.clear) {
                sigCanvasTestemunha.current.clear();
            }

            if (sigCanvas.current && sigCanvas.current.clear) {
                sigCanvas.current.clear();
            }

            setAss(null);
            setAssTestemunha(null);
        }
    };

    const assinatura = () => {
        if (calcularIdade(Associado.Nascimento) >= 65) {
            setShowCanvasTestemunha(true);
        } else {
            setShowCanvas(true);
            setAssinadoTestemunha(true);
        }
    };

    const { Nome, Inscricao, Cidade } = Associado;

    let bodyPdf = {};

    if (Associado) {
        bodyPdf = {
            nome: Nome,
            valor: Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(valorPagoInscricao),
            data: moment(dataInsertInscricao).format('DD/MM/YYYY'),
            numero_contrato: `${Inscricao}`,
            cidade: Cidade,
            uf: Associado.UF,
            email: Associado.AssEmail,
            forma_envio: '',
            responsavel_receber: nomeVendedor
        };
    }

    async function loadAssinatura() {
        await BuscarImagem(inscricao)
            .then(response => {
                if (response.ass_b64) {
                    setAssValor(true);
                }

                setImage(response.ass_b64);
            })
            .catch(error => {
                throw new Error(error);
            });

        await BuscarDadosTestemunha(inscricao).then(response => {
            setImageAssinaturaTestemunha(response.ass_b64);

            if (response.nome && response.cpf) {
                setDadosTestemunha({
                    nome: response.nome,
                    cpf: response.cpf,
                    nascimento: response.nascimento
                });
            }
        });
    }

    useEffect(() => {
        loadAssinatura();
    }, [inscricao]);

    const finalizar = dados => {
        AtualizarStatus(dados, Associado.Status)
            .then(response => {
                if (response.status === 200) {
                    showSuccess('Sucesso! contrato finalizado');
                    setTimeout(() => {
                        history.push('/lista-contratos/');
                    }, 2000);
                } else {
                    showError('Ops! Ocorreu um erro desconhecido');
                }
            })
            .catch(() => {
                showError('Ops! Erro de servidor');
            });
    };

    const showSuccess = message => {
        growl.current.show({
            severity: 'success',
            summary: '',
            detail: message
        });
    };

    const showError = message => {
        growl.current.show({
            severity: 'error',
            summary: '',
            detail: message
        });
    };

    function onClose(state) {
        setLoading(state);
    }

    useEffect(() => {
        (async () => {
            const servicosAdicionaisCadastrados =
                await servicosAdicionaisService.buscarServicosAdicionaisCadastrados(
                    inscricao
                );

            setValorServicosAdicionais(
                servicosAdicionaisCadastrados.reduce(
                    (accumulator, currentValue) =>
                        accumulator + currentValue.Taxa.valor,
                    0
                )
            );

            const valores = calculateZeloPrime(
                Associado,
                valorDep,
                valorServicosAdicionais
            );

            if (valores) {
                setValorTotal(valores.valorTotal);

                const { SubGrupo } = Associado;
                let totalDeMensalidades;

                switch (SubGrupo.trim()) {
                    case 'ZPC':
                        setMensalidadeBaseDep(valores.valorTotalSomaDependente);
                        setMensalidadeBase(Associado['ProdutosPreco.valorBase']);
                        break;
                    case 'ZTA':
                        setMensalidadeBaseDep(valores.valorTotalSomaDependente);
                        setMensalidadeBase(Associado['ProdutosPreco.valorBase']);
                        break;
                    case 'ZPCA':
                        totalDeMensalidades = 11;
                        setMensalidadeBaseDep(valores.valorTotalSomaDependente);
                        setMensalidadeBase(
                            Associado['ProdutosPreco.valorBase'] / totalDeMensalidades
                        );
                        break;
                    case 'ZPC4':
                        totalDeMensalidades = 47;
                        setMensalidadeBaseDep(valores.valorTotalSomaDependente);
                        setMensalidadeBase(
                            Associado['ProdutosPreco.valorBase'] / totalDeMensalidades
                        );
                        break;
                    default:
                        setMensalidadeBase(
                            Associado['ProdutosPreco.valorBase'].toString()
                        );
                }

                const servicosAdicionaisCadastradosAux =
                    servicosAdicionaisCadastrados.map(({ Taxa }) => ({
                        ...Taxa,
                        valor:
                            Taxa.valor !== null ?
                                Taxa.valor.toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL'
                                }) :
                                new Intl.NumberFormat('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL'
                                }).format('0')
                    }));

                setServicosAdicionais(servicosAdicionaisCadastradosAux);
            }
        })();
    }, [Associado, valorDep]);

    const buscaPdfComprovanteAdesao = async () => {
        await comprovanteAdesao.geraComprovanteAdesaoController(bodyPdf);
    };

    return (
        <div>
            <Growl ref={growl} />
            <Card
                className="tratar-scroll-card"
                header={header}
                title="Pagamento e assinatura"
            >
                {!assValor && Associado.Aceite === 'N' && valorInsc && (
                    <Message
                        style={{
                            marginTop: '7px',
                            height: '79%'
                        }}
                        closable="false"
                        severity="warn"
                        text="ENVIE ACEITE AO CLIENTE OU SOLICITE ASSINATURA EM TELA, ASSIM QUE CONFIRMADO O ACEITE PELO CLIENTE A OPÇÃO DE COBRAR ADESÃO SERA LIBERADA."
                    />
                )}
                <div className="p-col-12 p-md-12 p-lg-12 p-sm-12">
                    {retornoEtapasCadastro()}
                </div>
                <br />
                <br />
                <div className="p-grid p-fluid">
                    <>
                        {
                            !valorInsc && botaoAdesao && (
                                <div className="p-col-12" style={{ display: 'flex' }}>
                                    <div className="p-col-4">
                                        <ValorAdesao
                                            Associado={Associado}
                                            cidadeIbge={Number(
                                                Associado.CodigoCidadeIbge
                                            )}
                                            inscricao={props.match.params.inscricao}
                                            valor={valorInsc ? valorInsc : 0}
                                            subGrupo={Associado.SubGrupo}
                                            cidade={Associado.Cidade}
                                            title="Lançar Adesão"
                                            color="p-button-success"
                                            data-testid="btn-lancar-adesao"
                                            valueBase={mensalidadeBaseDep}
                                        />
                                    </div>

                                    <Message
                                        style={{
                                            marginTop: '7px',
                                            height: '79%'
                                        }}
                                        closable="false"
                                        severity="warn"
                                        text="Alguns botões estão inativos, pois não existe adesão lançada"
                                    />
                                </div>
                            )
                        }
                    </>

                    {Associado && Associado.Aceite !== 'S' && (
                        <ModalPlanoDesativado
                            mostrarFooter={true}
                            status={Associado['ProdutosPreco.status']}
                            plano={Associado['Produto.descricao']}
                            cidade={Associado.Cidade}
                            inscricao={Associado.Inscricao}
                            closable={false}
                        />
                    )}

                    {!assValor && Associado.Aceite === 'N' && valorInsc && (
                        <>
                            <div className="p-col-12 p-md-4 p-lg-3 p-sm-3">
                                <AceiEl
                                    inscricao={inscricao}
                                    email={Associado.AssEmail}
                                    celular={Associado.Celular}
                                    tipoCob={Associado.AssTipoCobranca}
                                    existsToken={Associado.payzentokencard}
                                    adesaoPaga={pagamentoAde}
                                />
                                <br />
                                <br />
                            </div>

                            <div className="p-col-12 p-md-4 p-lg-3 p-sm-3">
                                <Button
                                    label="Assinatura"
                                    onClick={() => setVisibleFullScreen(true)}
                                />
                            </div>

                            <div className="p-col-12 p-md-4 p-lg-3 p-sm-3">
                                {Associado.SubGrupo?.trim() !== 'ZTA' && (

                                    <ValorAdesao
                                        Associado={Associado}
                                        cidadeIbge={Number(Associado.CodigoCidadeIbge)}
                                        inscricao={props.match.params.inscricao}
                                        valor={valorInsc ? valorInsc : 0}
                                        subGrupo={Associado.SubGrupo}
                                        title="Editar Valor Adesão"
                                        valueBase={mensalidadeBaseDep}
                                    />
                                )}
                            </div>

                            <div className="p-col-12 p-md-4 p-lg-3 p-sm-3">
                                {(tipoPagamento != 'Dinheiro' && pgInscricao == null) ||
                                    !Associado['SignatureOrderLink.HashLink'] ?
                                    valorInsc &&
                                    registroAdesao && (
                                        <ValorAdesao
                                            Associado={Associado}
                                            cidadeIbge={Number(
                                                Associado.CodigoCidadeIbge
                                            )}
                                            inscricao={props.match.params.inscricao}
                                            valor={valorInsc ? valorInsc : 0}
                                            subGrupo={Associado.SubGrupo}
                                        />
                                    ) :
                                    ''}
                            </div>
                        </>
                    )}

                    {popUpAdesao && (
                        <div className="p-col-12 p-md-4 p-lg-3 p-sm-3">
                            <ValorAdesao
                                Associado={Associado}
                                cidadeIbge={Number(Associado.CodigoCidadeIbge)}
                                inscricao={props.match.params.inscricao}
                                valor={valorInsc ? valorInsc : 0}
                                subGrupo={Associado.SubGrupo}
                                TipoCobranca={Associado.AssTipoCobranca}
                                cidade={Associado.Cidade}
                                valueBase={valorTotal.replace(/[^\d,-]/g, '')}
                            />
                        </div>
                    )}

                    {Associado.Aceite === 'S' && (
                        <>
                            {!Associado.payzentokencard &&
                                pgInscricao === null &&
                                tipoPagamento != 'Dinheiro' &&
                                (
                                    <div className="p-col-12 p-md-4 p-lg-3 p-sm-6">
                                        <CobrarAdesao
                                            inscricao={inscricao}
                                            tipoCobranca={Associado.AssTipoCobranca}
                                            associado={Associado}
                                            mensalidade={
                                                Associado['Produto.valor'] + valorDep
                                            }
                                            valorAdesao={valorInsc}
                                            onClose={onClose}
                                        />
                                    </div>
                                )}

                            {!Associado.payzentokencard &&
                                pgInscricao &&
                                tipoPagamento != 'Dinheiro' &&
                                Associado.AssTipoCobranca === 7 &&
                                !dadosRecorrencia.length &&
                                (
                                    <div className="p-col-12 p-md-4 p-lg-3 p-sm-6">
                                        <CobrarAdesao
                                            inscricao={inscricao}
                                            tipoCobranca={Associado.AssTipoCobranca}
                                            associado={Associado}
                                            mensalidade={
                                                Associado['Produto.valor'] + valorDep
                                            }
                                            valorAdesao={valorInsc}
                                            onClose={onClose}
                                            dadosRecorrencia={dadosRecorrencia}
                                        />
                                    </div>
                                )}
                        </>
                    )}

                    {!Associado.payzentokencard && pagamentoAde !== true && (
                        <a href={`/editar-contrato/${inscricao}`}>
                            <Fab
                                style={{
                                    marginLeft: '80%',
                                    zIndex: '1',
                                    position: 'fixed',
                                    bottom: '20px',
                                    right: '15px',
                                    float: 'center'
                                }}
                                color="secondary"
                                aria-label="edit"
                            >
                                <EditIcon />
                            </Fab>
                        </a>
                    )}

                    {Object.keys(logsAceite).length !== 0 && (
                        <div className="p-col-12 p-md-4 p-lg-3 p-sm-6">
                            <LogAceite data={logsAceite} />
                        </div>
                    )}

                    {pgInscricao && Associado.Aceite === 'S' && origemCarne && (
                        <div className="p-col-12 p-md-4 p-lg-3 p-sm-6">
                            <a
                                href={linkCarne}
                                download={`${Associado.Inscricao}-${Associado.Nome}`}
                                rel="noreferrer"
                            >
                                <Button
                                    disabled={loadingCarne}
                                    icon={loadingCarne ? 'pi pi-spin pi-spinner' : ''}
                                    className="btn-primary"
                                    label="baixar carnê"
                                />
                            </a>
                        </div>
                    )}

                    <div className="p-col-12 p-md-4 p-lg-3 p-sm-6">
                        {Object.keys(statusRemessa).length !== 0 && (
                            <div>
                                <StatusRemessa dataParam={statusRemessa} formulario={Associado} />
                            </div>
                        )}

                        {!renderPdf &&
                            valorPagoInscricao &&
                            tipoPagamento === 'Dinheiro' ?
                            (
                                <div>
                                    <Button
                                        disabled={
                                            loadingAssociado ||
                                            !Object.keys(bodyPdf)?.length
                                        }
                                        icon={
                                            loadingAssociado ? 'pi pi-spin pi-spinner' : ''
                                        }
                                        type="submit"
                                        label="2° Via do Comprovante"
                                        onClick={buscaPdfComprovanteAdesao}
                                    />
                                </div>
                            ) : null}
                    </div>

                    {Associado && pgInscricao && (
                        <div className="p-col-12 p-md-4 p-lg-3 p-sm-6">
                            <TrocaCartao inscricao={inscricao} associado={Associado} tipoCobranca={Associado.AssTipoCobranca} />
                        </div>
                    )}

                    {
                        assValor &&
                        Associado.SubGrupo?.trim() === 'ZP4' &&
                        pgInscricao && (
                            <div className="p-col-12 p-md-4 p-lg-3 p-sm-6">
                                <ParcelarMensalidade
                                    inscricao={inscricao}
                                    associado={Associado}
                                    valorTotal={valorTotal}
                                />
                            </div>
                        )
                    }
                </div>
                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-12 p-lg-12 p-sm-12">
                        <Fieldset legend="Contratante">
                            <div className="p-grid p-fluid">
                                <div className="p-col-12 p-md-12">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Nome"
                                            className="p-col-fixed"
                                            style={{ width: '50px' }}
                                        >
                                            Nome
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                placeholder="Nome"
                                                name="Nome"
                                                id="Nome"
                                                value={Associado.Nome}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Telefone"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Celular
                                        </label>
                                        <div className="p-col">
                                            <InputMask
                                                name="Celular"
                                                id="Telefone"
                                                value={Associado.Celular}
                                                disabled
                                                mask="(99) 99999-9999"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Email"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Email
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Email"
                                                id="Email"
                                                value={Associado.AssEmail}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Idade"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Nascimento
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Idade"
                                                id="Idade"
                                                value={moment(Associado.Nascimento)
                                                    .add(3, 'hours')
                                                    .format('DD/MM/YYYY')}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Telefone"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Carência
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Carencia"
                                                id="Carencia"
                                                value={moment(Associado.CarenFuneral)
                                                    .add(3, 'hours')
                                                    .format('DD/MM/YYYY')}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Email"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Mensalidade base
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Mensalidade"
                                                id="Mensalidade"
                                                value={new Intl.NumberFormat('pt-BR', {
                                                    style: 'currency',
                                                    currency: 'BRL'
                                                }).format(mensalidadeBase)}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <div className="p-field p-grid ">
                                        <label
                                            htmlFor="Email"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Valor do desconto
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                className="bordaMensalidadeDesconto"
                                                name="mensalidadeDesconto"
                                                id="mensalidadeDesconto"
                                                value={new Intl.NumberFormat('pt-BR', {
                                                    style: 'currency',
                                                    currency: 'BRL'
                                                }).format(
                                                    Associado.valorComDesconto ?
                                                        Associado.valorComDesconto :
                                                        ''
                                                )}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Idade"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Mensalidade total
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Mensalidade"
                                                id="Mensalidade"
                                                value={valorTotal}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Idade"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Codigo Supervisor
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Supervisor"
                                                id="Supervisor"
                                                value={supervisor}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Telefone"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Cod Coordenador
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Coordenador"
                                                id="Coordenador"
                                                value={coordenador}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Email"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Cod vendedor
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Vendedor"
                                                id="Mensalidade"
                                                value={Associado.Vendedor}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                {dadosTestemunha && (
                                    <>
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field p-grid">
                                                <label
                                                    htmlFor="nomeTestemunha"
                                                    className="p-col-fixed"
                                                    style={{ width: '90px' }}
                                                >
                                                    Nome da Testemunha
                                                </label>
                                                <div className="p-col">
                                                    <InputText
                                                        name="nomeTestemunha"
                                                        id="nomeTestemunha"
                                                        value={dadosTestemunha.nome.toUpperCase()}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field p-grid">
                                                <label
                                                    htmlFor="cpfTestemunha"
                                                    className="p-col-fixed"
                                                    style={{ width: '90px' }}
                                                >
                                                    CPF da Testemunha
                                                </label>
                                                <div className="p-col">
                                                    <InputMask
                                                        name="cpfTestemunha"
                                                        id="cpfTestemunha"
                                                        value={dadosTestemunha.cpf}
                                                        mask="999.999.999-99"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </Fieldset>
                        <br />
                        <h2>Dependentes</h2>
                        <br />
                        <DataTable value={dependentes}>
                            <Column field="Seq" header="Sequência" />
                            <Column field="Nome" header="Nome" />
                            <Column field="Nascimento" header="Nascimento" />
                            <Column field="Parentesco" header="Parentesco" />
                            <Column
                                body={bodyTemplateValorDependentes}
                                header="Valor"
                            />
                        </DataTable>
                        <br />
                        <br />
                        <br />
                        <h2>Serviços Adicionais</h2>
                        <br />
                        <DataTable value={servicosAdicionais}>
                            <Column field="nome" header="Nome" />
                            <Column field="valor" header="Valor" />
                        </DataTable>
                        <br />
                        <br />
                    </div>
                </div>
                <div id="assinaturaSideBar">
                    <Sidebar
                        visible={visibleFullScreen}
                        fullScreen
                        baseZIndex={1000000}
                        className="sidebar-fullscreen"
                        onHide={() => setVisibleFullScreen(false)}
                    >
                        <div className="content-container">
                            <div className="p-grid p-fluid">
                                {!showCanvasTestemunha &&
                                    !showCanvas &&
                                    !assinadoTitular &&
                                    !assinadoTestemunha ? (
                                    <>
                                        <div className="p-col-12 p-md-12 p-lg-4 p-sm-4">
                                            <Button
                                                type="submit"
                                                label="Assinar"
                                                onClick={() => assinatura()}
                                            />
                                        </div>
                                        <div className="p-col-12 p-md-3 p-lg-3 p-sm-3">
                                            <button
                                                type="submit"
                                                icon="pi pi-plus"
                                                iconPos="left"
                                                className="btn-primary"
                                                onClick={() => setVisibleFullScreen(false)}
                                            >
                                                Fechar
                                            </button>
                                        </div>
                                        <br />
                                        <br />
                                        <div className="p-col-12 p-md-12 p-lg-12 p-sm-12">
                                            <img
                                                src={image}
                                                style={{ maxWidth: '150px' }}
                                                alt="img"
                                            />
                                            <p
                                                style={{
                                                    marginTop: '10px',
                                                    fontSize: '.8em'
                                                }}
                                            >
                                                Assinatura Titular
                                            </p>
                                            {imageAssinaturaTestemunha && (
                                                <>
                                                    <img
                                                        src={imageAssinaturaTestemunha}
                                                        style={{
                                                            width: '300px',
                                                            marginTop: '30px',
                                                            maxWidth: '150px'
                                                        }}
                                                        alt="img"
                                                    />
                                                    <p
                                                        style={{
                                                            marginTop: '10px',
                                                            fontSize: '.8em'
                                                        }}
                                                    >
                                                        Assinatura Testemunha
                                                    </p>
                                                </>
                                            )}
                                        </div>
                                        <div className={loading}>
                                            <ProgressSpinner
                                                style={{
                                                    width: '300px',
                                                    height: '150px',
                                                    display: 'flex',
                                                    margin: '0 auto',
                                                    marginTop: '8%'
                                                }}
                                                strokeWidth="1"
                                                fill="#EEEEEE"
                                                animationDuration=".5s"
                                            />
                                        </div>
                                        <div className="quinhentos p-col-6 p-md-6">
                                            {sucesso ? (
                                                <Message
                                                    severity="success"
                                                    text="Assinatura Salva"
                                                />
                                            ) : erro ? (
                                                <Message
                                                    severity="error"
                                                    text="Ops, não conseguimos salvar"
                                                />
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    </>
                                ) : showCanvasTestemunha ? (
                                    <>
                                        <div className="infoAssintauraTestemunha">
                                            <p className="aviso">
                                                *Essa tela é exibida porque o titular tem mais
                                                de 65 anos e deve ser colhida as informações de
                                                uma testemunha.
                                            </p>
                                            <h2>Informações da Testemunha</h2>
                                            <form className="inputsTestemunha p-grid p-fluid">
                                                <div className="label-form-testemunha p-col-12 p-md-4">
                                                    <input
                                                        type="text"
                                                        placeholder="Nome"
                                                        value={formTestemunha.nome}
                                                        onChange={changeNomeTestemunha}
                                                        style={{
                                                            borderColor:
                                                                formTestemunha.nome.length ===
                                                                    0 && !errFormTestemunhaNome ?
                                                                    '#b3b3b3' :
                                                                    errFormTestemunhaNome ?
                                                                        'red' :
                                                                        'green',
                                                            boxShadow:
                                                                formTestemunha.nome.length ===
                                                                    0 && !errFormTestemunhaNome ?
                                                                    '' :
                                                                    errFormTestemunhaNome ?
                                                                        '5px 2px 7px rgba(245, 37, 0, 0.5)' :
                                                                        '3px 1px 7px rgba(12, 224, 65, 0.5)'
                                                        }}
                                                    />
                                                    {errFormTestemunhaNome && (
                                                        <p className="errorForm">
                                                            {errFormTestemunhaNome}
                                                        </p>
                                                    )}
                                                </div>
                                                <div className="label-form-testemunha p-col-12 p-md-4">
                                                    <InputMask
                                                        type="text"
                                                        placeholder="CPF"
                                                        mask="999.999.999-99"
                                                        value={formTestemunha.cpf}
                                                        onChange={changeCpfTestemunha}
                                                        style={{
                                                            borderColor:
                                                                formTestemunha.cpf.length ===
                                                                    0 && !errFormTestemunhaCpf ?
                                                                    '#b3b3b3' :
                                                                    errFormTestemunhaCpf ?
                                                                        'red' :
                                                                        'green',
                                                            boxShadow:
                                                                formTestemunha.cpf.length ===
                                                                    0 && !errFormTestemunhaCpf ?
                                                                    '' :
                                                                    errFormTestemunhaCpf ?
                                                                        '5px 2px 7px rgba(245, 37, 0, 0.5)' :
                                                                        '3px 1px 7px rgba(12, 224, 65, 0.5)'
                                                        }}
                                                    />
                                                    {errFormTestemunhaCpf && (
                                                        <p className="errorForm">
                                                            {errFormTestemunhaCpf}
                                                        </p>
                                                    )}
                                                </div>
                                                <div className="label-form-testemunha p-col-12 p-md-4">
                                                    <Calendar
                                                        readOnlyInput
                                                        locale={ptBR}
                                                        monthNavigator
                                                        placeholder="Nascimento"
                                                        dateFormat="dd/mm/yy"
                                                        yearNavigator
                                                        yearRange="1900:2030"
                                                        value={formTestemunha.nascimento}
                                                        onChange={e => {
                                                            changeNascimentoTestemunha(e);
                                                            handleNascimento(e);
                                                        }}
                                                        style={{
                                                            borderColor:
                                                                formTestemunha.nascimento
                                                                    .length === 0 &&
                                                                    !errFormTestemunhaNascimento ?
                                                                    '#b3b3b3' :
                                                                    errFormTestemunhaNascimento ?
                                                                        'red' :
                                                                        'green',
                                                            boxShadow:
                                                                formTestemunha.nascimento
                                                                    .length === 0 &&
                                                                    !errFormTestemunhaNascimento ?
                                                                    '' :
                                                                    errFormTestemunhaNascimento ?
                                                                        '5px 2px 7px rgba(245, 37, 0, 0.5)' :
                                                                        '3px 1px 7px rgba(12, 224, 65, 0.5)'
                                                        }}
                                                    />
                                                    {errFormTestemunhaNascimento && (
                                                        <p className="errorForm">
                                                            {errFormTestemunhaNascimento}
                                                        </p>
                                                    )}
                                                </div>
                                            </form>
                                            <h2>Assinatura da Testemunha</h2>
                                        </div>
                                        <SignaturePad
                                            ref={sigCanvasTestemunha}
                                            canvasProps={{
                                                className:
                                                    'signatureCanvas p-col-12 p-md-12 p-lg-12 p-sm-12'
                                            }}
                                        />
                                        <DialogAvisoAssinatura
                                            openDialog={openDialogAssinaturaTestemunha}
                                            setOpenDialog={setOpenDialogAssinaturaTestemunha}
                                        />
                                        <div className={loading}>
                                            Carregando...
                                            <ProgressSpinner
                                                style={{
                                                    width: '50px',
                                                    height: '50px'
                                                }}
                                                strokeWidth="1"
                                                fill="#EEEEEE"
                                                animationDuration=".5s"
                                            />
                                        </div>
                                    </>
                                ) : (
                                    <div className="p-col-12 p-md-12 p-lg-12 p-sm-12">
                                        <div className="infoAssintauraTestemunha">
                                            <h2>Assinatura Titular</h2>
                                        </div>
                                        <SignaturePad
                                            ref={sigCanvas}
                                            canvasProps={{
                                                className:
                                                    'signatureCanvas p-col-12 p-md-12 p-lg-12 p-sm-12'
                                            }}
                                        />

                                        <DialogAvisoAssinatura
                                            openDialog={openDialogAssinaturaTitular}
                                            setOpenDialog={setOpenDialogAssinaturaTitular}
                                            assinante="TITULAR"
                                        />

                                        <div className={loading}>
                                            Carregando...
                                            <ProgressSpinner
                                                style={{
                                                    width: '50px',
                                                    height: '50px'
                                                }}
                                                strokeWidth="1"
                                                fill="#EEEEEE"
                                                animationDuration=".5s"
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="footer">
                            <br />
                            {showCanvasTestemunha || showCanvas ? (
                                <div className="p-grid p-fluid">
                                    <div className="p-col-12 p-md-3 p-lg-3 p-sm-3">
                                        <button
                                            type="submit"
                                            icon="pi pi-plus"
                                            iconPos="left"
                                            className={
                                                showCanvasTestemunha && !formTestemunhaValid ?
                                                    'btn-disabled' :
                                                    'btn-primary'
                                            }
                                            disabled={
                                                showCanvasTestemunha && !formTestemunhaValid
                                            }
                                            onClick={() => save(1)}
                                        >
                                            Assinar
                                        </button>
                                    </div>
                                    <div className="p-col-12 p-md-3 p-lg-3 p-sm-3">
                                        <Button
                                            type="submit"
                                            label="Limpar"
                                            onClick={() => clear(1)}
                                        />
                                    </div>
                                    <div className="p-col-12 p-md-3 p-lg-3 p-sm-3">
                                        <button
                                            type="submit"
                                            icon="pi pi-plus"
                                            iconPos="left"
                                            className="btn-primary"
                                            onClick={e => setVisibleFullScreen(false)}
                                        >
                                            Fechar
                                        </button>
                                    </div>
                                </div>
                            ) : assinadoTestemunha && assinadoTitular ? (
                                <div className="p-grid p-fluid">
                                    <div className="p-col-12 p-md-3 p-lg-3 p-sm-3">
                                        <button
                                            type="submit"
                                            icon="pi pi-plus"
                                            iconPos="left"
                                            className="btn-primary"
                                            onClick={() => save(2)}
                                        >
                                            Confirmar
                                        </button>
                                    </div>
                                    <div className="p-col-12 p-md-3 p-lg-3 p-sm-3">
                                        <button
                                            type="submit"
                                            icon="pi pi-plus"
                                            iconPos="left"
                                            className="btn-primary"
                                            onClick={() => clear(2)}
                                        >
                                            Voltar
                                        </button>
                                    </div>
                                    <div className="p-col-12 p-md-3 p-lg-3 p-sm-3">
                                        <button
                                            type="submit"
                                            icon="pi pi-plus"
                                            iconPos="left"
                                            className="btn-primary"
                                            onClick={e => setVisibleFullScreen(false)}
                                        >
                                            Fechar
                                        </button>
                                    </div>
                                    {loadingAssinaturas && (
                                        <div className="carregando">
                                            <ProgressSpinner
                                                style={{
                                                    width: '80px',
                                                    height: '50px'
                                                }}
                                                strokeWidth="1"
                                                fill="#EEEEEE"
                                                animationDuration=".5s"
                                            />
                                            <h2>Carregando</h2>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    </Sidebar>
                </div>
                {
                    (aceiteUnico && Associado) || (assValor && Associado) ? (
                        <Pdf
                            inscricao={inscricao}
                            dependentes={dependentes}
                            Associado={Associado}
                            valorDep={valorDep}
                            valorAdesao={valorInsc}
                        />
                    ) : (
                        <></>
                    )
                }

                <div className="assinaturas-do-cliente">
                    {image && (
                        <div className="image-assinatura">
                            <img
                                src={image}
                                style={{
                                    width: '300px',
                                    maxHeight: '200px'
                                }}
                                alt="img"
                            />
                            <p>Assinatura do cliente</p>
                        </div>
                    )}
                    {imageAssinaturaTestemunha && (
                        <>
                            {image && <div className="divider-assinaturas"></div>}
                            <div className="image-assinatura">
                                <img
                                    src={imageAssinaturaTestemunha}
                                    style={{
                                        width: '300px',
                                        maxHeight: '200px'
                                    }}
                                    alt="img"
                                />
                                <p>Assinatura da testemunha</p>
                            </div>
                        </>
                    )}
                </div>

                <br />
                {
                    aceiteUnico ||
                    (assValor && (
                        <Button
                            type="submit"
                            label="Salvar Contrato"
                            onClick={() => finalizar(inscricao)}
                            className="p-col-12 p-md-6 p-lg-6 p-sm-6"
                        />
                    ))
                }
            </Card >
        </div >
    );
};

export default Assinatura;
